<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="text-hero-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div class="text">
                        <h1 v-test:title class="title">{{ title }}</h1>
                        <markdown-content :content="text" />
                    </div>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';

    export default {
        name: 'text-hero-section',

        components: {
            MarkdownContent,
        },

        props: {
            title: {
                type: String,
                required: true,
            },

            text: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    $desktop-breakpoint: md;

    .text-hero-section {
        font-size: rem(20px);
        line-height: 1.33;
        text-align: center;
        padding-top: 15px;
        padding-bottom: 28px;

        @include media-breakpoint-up($desktop-breakpoint) {
            font-size: rem(24px);
            padding-top: 50px;
        }
    }

    .title {
        margin-bottom: 4px;
    }

    .markdown-content ::v-deep {
        max-width: 640px;
        margin-left: auto;
        margin-right: auto;
        color: secondary-palette(4);

        p:not(:last-child) {
            margin-bottom: 1.5em;

            @include media-breakpoint-up($desktop-breakpoint) {
                margin-bottom: 2.5em;
            }
        }

        p:last-child {
            margin-bottom: 0;
        }
    }
</style>
